import React from "react";

import {
  Image
} from '@lockerpm/design';

import images from "../../assets/images";

const AuthLogo = (props) => {
  const { AuthLogo } = images;
  const {
    className = 'mb-8',
    boxWidth = 60,
    boxHeight = 60,
    height = 36,
    width = 36,
  } = props;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="border border-solid border-gray-100 rounded-xl flex items-center justify-center bg-white" style={{ width: boxWidth, height: boxHeight }}>
        <Image
          src={AuthLogo}
          preview={false}
          height={height}
          width={width}
        />
      </div>
    </div>
  );
}

export default AuthLogo;